

export const checkIsRequired = async ({ccConfig, items}) => {

    const showMissingImageWarnings = ccConfig.showMissingImageWarnings ?? true;
    const showTextWarnings = ccConfig.showTextWarnings ?? true;

    for (const item of items) {
        const surface = item.parentContainer.parentComponent.name;
        const isRequired = ccConfig.templateConfigurations[surface]?.[item?.name]?.isRequired ?? false;
        if (
            item.type === "PlaceholderItem" &&
            item.name !== "" &&
            item.content === null &&
            showMissingImageWarnings &&
            item?.visible &&
            item?.visualizationPermissions?.noPrint === false &&
            item?.visualizationPermissions?.noShow === false &&
            isRequired
        ) {
            return true;
        } else if (
            (item.type === "BoundedTextItem" || item.type === "PathBoundedTextItem") &&
            item._locked === false &&
            item.text === "" &&
            showTextWarnings &&
            isRequired
        ) {
            return true
        }
    }
    return false
};
